import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default function CTASection() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    ScrollTrigger.create({ trigger: el, start: 'top 84%',
      onEnter: () => gsap.to(el.querySelectorAll('.gs'), { opacity:1, scale:1, y:0, duration:.7, stagger:.1, ease:'back.out(1.3)' })
    });
  }, []);

  return (
    <section className="sec-cta" id="cta" ref={ref}>
      <div className="blob b1" />
      <div className="cta-in">
        <div className="cta-badge gs">
          <div className="bdot" />
          <span>Ready to Join 500+ Happy Clients?</span>
        </div>
        <h2 className="cta-h2 gs">Over 500 brands have accelerated and succeeded in their digital ventures with <em>KodersPedia?</em></h2>
        <h3 className="cta-h3 gs">Are you the next? </h3>
        <p className="cta-sub gs">Join businesses that trust KodersPedia to create reliable websites, mobile applications and custom digital products.</p>
        <div className="cta-btns gs">
          <a href="https://koderspedia.com/" className="btn-cw" target="_blank" rel="noopener noreferrer">
            Get Free Consultation
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </a>
          <a href="https://koderspedia.com/" className="btn-co" target="_blank" rel="noopener noreferrer">View Portfolio ↗</a>
        </div>
        <div className="cta-pills gs">
          <span className="cp"><span className="cp-dot" />No commitment</span>
          <span className="cp"><span className="cp-dot" />Reply within 24hrs</span>
          <span className="cp"><span className="cp-dot" />Free project estimate</span>
        </div>
        <p className="cta-close gs">Over 500 brands have accelerated and succeeded in their digital ventures with KodersPedia. <strong>Are you the next?</strong></p>
      </div>
    </section>
  );
}
